<template>
  <bvue-ui-view class="flex flex-col">
    <h1>Paises</h1>
    <p>Pulsa en la fila para editar la conversión.</p>
    <div class="flex-1 overflow-scroll relative">
      <sortable-table :items="items" :columns="columns" startSort="id" @rowSelected="rowSelected"/>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import SortableTable from '@/components/SortableTable'
export default {
  name: 'Countries',
  data() {
    return {
      columns: [
        {
          key: 'id',
          name: 'cod',
          align: 'center',
          sortable: true,
          type: 'text'
        },
        {
          key: 'name',
          name: 'nombre(EN)',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'native',
          name: 'nativo',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'currency',
          name: 'moneda',
          align: 'center',
          sortable: true,
          type: 'text'
        },
        {
          key: 'conversion',
          name: 'conversión',
          align: 'center',
          sortable: true,
          type: 'text'
        }
      ]
    }
  },
  components: {
    SortableTable
  },
  computed: {
    items() {
      var response = []
      const itemsObj = this.$store.state.countries.items
      for (const key in itemsObj) {
          response.push(itemsObj[key])
      }
      return response
    }
  },
  methods: {
    rowSelected(args) {
      if (args.length > 1) {
        const item = args[1]
        this.updateConversion(item.id, item.conversion)
      }
    },
    async updateConversion(code, pre) {
      const options = {title: 'Nueva conversión', okLabel: 'Cambiar', prompt: {value: pre, invalidMessage:''}}
      const msg = 'Introduce el nuevo factor de conversión. recuerda que los decimales se separn con un punto Ej: 1.5'
      const response = await this.$dialogs.prompt(msg, options)
      if (response.ok) {
        var val = parseFloat(response.value)
        if (val > 0) {
          firebase.firestore.collection('countries').doc(code).update({conversion: val})
        } else {
          alert('Debes introducir un número!')
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/Countries.vue